import React, { useEffect } from "react";

// Importing Packages
import { v4 as uuidv4 } from "uuid";

//Importing Libraries
var Highcharts = require("highcharts");
// require('highcharts/highmaps')(Highcharts);
require("highcharts/modules/map")(Highcharts);
require("highcharts/modules/exporting")(Highcharts);

function LargePie(props) {
  let id = generateRandomGuid();
  function generateRandomGuid() {
    return uuidv4();
  }

  useEffect(() => {
    function renderChart(id,colorset) {
      // Data retrieved from https://netmarketshare.com
      Highcharts.chart(`lp-${id}`, {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie",
          backgroundColor: null,
          // width: 183,
          // height: 183,
        },
        title: {
          text: "",
        },
        tooltip: {
          pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
        },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            borderWidth: 0,
            dataLabels: {
              enabled: false,
              format: "<b>{point.name}</b>: {point.percentage:.1f} %",
            },
          },
        },
        credits: {
          enabled: false,
        },

        exporting: {
          enabled: false,
        },
        series: [
          {
            name: "NWC",
            colorByPoint: true,
            data: [
              {
                name: "NWC",
                y: 70,
                /* sliced: true, */
                selected: true,
                // color: "#24A0D9",
                color: colorset,
              },
              {
                name: "NWC",
                y: 40,
                color: "transparent",
              },
            ],
          },
        ],
      });
    }

    renderChart(id,props.colorset);
  }, [id,props.colorset]);

  return <div id={`lp-${id}`}></div>;
}

export default LargePie;
